const fromDtoToSalonCore = (dto) =>
  dto
    ? {
        hideDeletedStylistColumn: dto.hide_deleted_stylist_column,
        // TODO: add all the rest of the fields here
      }
    : void 0;

export default fromDtoToSalonCore;
